const container = document.querySelector('.product__slides.product-single__photos');

if(container) {
    let target = document.querySelector('.product-single__slide-counter--current');    
    const images = document.querySelectorAll('.product__slide');
    
    const options = {
        rootMargin: '0px',
        threshold: 1.0
    };

    const doThings = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {

                target.innerHTML = entry.target.dataset.imgIndex;
            }
        });
    }

    const observer = new IntersectionObserver(doThings, { ...options, threshold: 0.4 });

    images.forEach(target => {
        observer.observe(target);
    });
}
